var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('CustomerLocationsComponent',{attrs:{"types":_vm.types,"areas":_vm.areas}})],1)],1),_c('v-row',[_c('v-col',[_c('CustomerLocationAreasComponent',{on:{"loaded":(value) => _vm.areas = value}})],1)],1),_c('v-row',[_c('v-col',[_c('CustomerLocationTypesComponent',{on:{"loaded":_vm.onTypesLoaded}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }